import { safeLocalStorage } from 'helpers/localStorage'
import { NO_PERMISSION, SIGN_IN } from 'routes'

export const redirectTo = (defaultPath: string) => {
  const redirectTo = safeLocalStorage.getItem('redirectTo')
  if (redirectTo) safeLocalStorage.removeItem('redirectTo')
  return redirectTo ? redirectTo : defaultPath
}

export const setRedirectTo = (pathname: string) => {
  safeLocalStorage.setItem('redirectTo', pathname)
}

/** Whether a sign-in page's `reason` says the session ended (timed out or was rejected), not a plain sign-in. */
export const isSessionEndedReason = (reason: string | null): boolean =>
  reason === 'sessionExpired' || reason === 'tokenExpired'

/**
 * Saves the current page URL as the post-login redirect target,
 * unless the user is already on the sign-in page.
 */
export const saveCurrentUrlForRedirect = () => {
  const currentPath = window.location.pathname + window.location.search
  if (currentPath !== SIGN_IN && !currentPath.startsWith(`${SIGN_IN}?`) && !currentPath.startsWith(NO_PERMISSION)) {
    safeLocalStorage.setItem('redirectTo', currentPath)
  }
}
